import { signInWithCustomToken } from "api/firebase";
import {
  cancelSessionSwitch,
  markSessionSwitchInProgress,
} from "tools/auth/sessionSync";
import {
  LastLoginMethod,
  writeLastLoginMethod,
} from "tools/auth/lastLoginMethod";
import { APP_PATH } from "view/routes";

/**
 * Turns a Firebase custom token into a live session and leaves the page.
 *
 * Shared by every Google entry point — the login page, the two invite pages
 * and the embedded show sign-up — so the order of the three things that have
 * to happen around `signInWithCustomToken` (flag sibling tabs, release them on
 * failure, record the sign-in method) is written once.
 *
 * Navigates away on success, so nothing after the call runs.
 */
export const completeGoogleSignIn = async (
  customToken: string,
  redirectTo: string = APP_PATH
): Promise<void> => {
  markSessionSwitchInProgress();

  try {
    await signInWithCustomToken(customToken);
  } catch (error) {
    cancelSessionSwitch();
    throw error;
  }

  writeLastLoginMethod(LastLoginMethod.Google);
  window.location.replace(redirectTo);
};

export default completeGoogleSignIn;
